<template>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">属性或事件</th>
          <th scope="col">类型</th>
          <th scope="col">默认</th>
          <th scope="col">说明</th>
        </tr>
      </thead>
    <tbody>
      <tr v-for="(prop, index) in props" :key="index">
        <th scope="row">{{prop.name}}</th>
        <td>{{prop.type}}</td>
        <td>{{prop.default || '-'}}</td>
        <td>{{prop.desc}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
interface PropDetail {
  name: string;
  type: string;
  desc: string;
  default?: string;
}
export default defineComponent({
  props: {
    props: {
      type: Array as PropType<PropDetail[]>,
      required: true
    }
  }
})
</script>
